import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { forwardRef } from 'react';
import { useComparisonTableContext } from './Context';
import ComparisonTableFooter from './Footer';
import ComparisonTableHeader from './Header';
import ComparisonTableRow from './Row';

type ComparisonTableColumnProps = { column: ComparisonTableColumn; columnIndex: number };

const Column = forwardRef<HTMLDivElement, ComparisonTableColumnProps>(
  ({ column, columnIndex }, ref) => {
    const { driversIds } = useComparisonTableContext();
    return (
      <>
        <ComparisonTableHeader
          key={`comparison-table-header-${columnIndex}`}
          column={column}
          index={columnIndex}
          innerRef={ref}
        />
        {driversIds.map((driverId, driverIndex) => {
          const correspondingDriver = column.drivers?.find(
            localDriver => localDriver.id === driverId,
          );
          if (!correspondingDriver) {
            return null;
          }
          return (
            <ComparisonTableRow
              key={`comparison-table-driver-${columnIndex}-${driverId}`}
              column={column}
              columnIndex={columnIndex}
              driver={correspondingDriver}
              isLastDriver={driverIndex === driversIds.length - 1}
            />
          );
        })}
        <ComparisonTableFooter
          key={`comparison-table-footer-${columnIndex}`}
          column={column}
          columnIndex={columnIndex}
        />
      </>
    );
  },
);

export default Column;
